import { ModalProps } from '../../../services/modals.service';
import { KeyedMutator } from 'swr';
import React from 'react';
import { api } from '../../../services/api';
import { AlertService } from '../../../services/alert.service';
import { CleanUser } from '../../../export-types/cleaned-types';
import { useModalClose } from '../../../utils/useModalClose';
import { trpc } from '../../../api/trpc';

interface DeleteUserModalProps extends ModalProps {
  user: CleanUser;
  mutate?: KeyedMutator<any>;
}

export const DeleteEmployeeModal = ({
  user,
  close,
  mutate,
}: DeleteUserModalProps) => {
  const modalRef = useModalClose(close);

  const handleDelete = async () => {
    try {
      await trpc.employee.employeeChange.markAsDeleted.mutate(user.id);

      AlertService.success('Пользователь успешно удалён');
      mutate?.();
    } catch (error: any) {
      AlertService.error(error?.message || 'Ошибка удаления');
    } finally {
      close();
    }
  };

  return (
    <div className="modal-dialog mw-400" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-header border-bottom-0 p-4">
          <button type="button" className="btn-close" onClick={() => close()} />
        </div>

        <div className="modal-body text-center p-4">
          <i className="bi bi-exclamation-triangle-fill mb-3 fs-1 text-danger"></i>

          <h3 className="fw-bold mb-3">Удалить сотрудника?</h3>

          <p className="text-muted mb-4">
            Вы действительно хотите удалить сотрудника{' '}
            <strong>{user.name || user.phone}</strong>?<br />
            Это действие нельзя отменить.
          </p>

          <button
            type="button"
            className="btn btn-danger w-100 mb-3"
            onClick={handleDelete}
          >
            Удалить
          </button>

          <button
            type="button"
            className="btn btn-light w-100"
            onClick={() => close()}
          >
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
};
